import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'

import type { paths } from '../gen/tintin-organization-service-schema'
import config from './req.config'

export type { paths as OrganizationPaths }

export const organizationServiceReq = createFetchClient<paths>({
  ...config,
})

export const organizationServiceQuery = createClient<paths>(organizationServiceReq)
